import m from 'mithril';
import {trans} from "./helpers";
var Prosemirror = require("./prosemirror/index");

let editor_state = {
    id_exercise: null,
    is_admin: false,
    exercise: null,
    editor: null,

    images_cache: {},
    videos_cache: {},
}

function replaceElementContent(html, element, replace_with) {
    let element_begin = "<" + element;
    let element_end = "</" + element + ">";

    let i1 = html.indexOf(element_begin);

    html = html.replace('contenteditable="false"', '');
    html = html.replace('draggable="true"', '');
    html = html.replace('status="rendered"', '');
    html = html.replace('status="parsed"', '');


    while (i1 != -1) {
        i1 = html.indexOf(">", i1+1)+1;

        let i2 = html.indexOf(element_end, i1+1); 
        let to_replace = html.substring(i1, i2);

        html = html.replace(to_replace, replace_with);

        i1 = html.indexOf(element_begin, i1 +1);
    }

    html = html.replace(/  +/g, ' ')

    return html;
}

function parseToCustom() {
    let content_str = editor_state.editor.dom.innerHTML;

    content_str = replaceElementContent(content_str, 'ct-video', '');
    content_str = replaceElementContent(content_str, 'ct-image', '');
    // console.log(content_str);
    // editor_state.exercise.content = content_str;

    return content_str;

    // console.log('TUKI!!', editor_state.editor.dom.innerHTML);
    // let content = document.createElement("div");
    // // console.log('CONTENT', content);
    // // content.innerHTML = editor_state.exercise.content;
    // content.innerHTML = editor_state.editor.dom.innerHTML.trim();
    // content.innerHTML = '';
    // editor_state.exercise.content = content.innerHTML;
    // console.log('CONTENT', content);
    // return;

    // let images = content.querySelectorAll('ct-image');

    // images.forEach(img => {
    //     img.removeAttribute('status');
    //     img.removeAttribute('contenteditable');
    //     img.removeAttribute('draggable');
    //     img.innerHTML = '';
    // });

    // let videos = content.querySelectorAll('ct-video');

    // videos.forEach(video => {
    //     video.removeAttribute('status');
    //     video.removeAttribute('contenteditable');
    //     video.removeAttribute('draggable');
    //     video.innerHTML = 'XXX';
    // });

    // editor_state.exercise.content = content.innerHTML;

    // console.log(editor_state.exercise.content);
}

function saveExercise() {
    
    // TODO: sanitize!!
    // console.log(editor_state.editor);


    editor_state.exercise.content = editor_state.editor.dom.innerHTML;

    editor_state.exercise.content = parseToCustom();

    // console.log(editor_state.exercise.content);

    m.request({
        method: "POST",
        url: "/api/exercises/"+editor_state.id_exercise,
        responseType: "json",
        body: editor_state.exercise
    }).then(function(data) {
        alert("Exercise saved!");
    }).catch(e => {
        if (e.response && e.response.error && e.response.error.description) {
            alert(e.response.error.description);
        } else {
            alert('Trouble saving exercise');
        }
    });
}


function parseCustomTags(containerSelector) {
    let container = document.querySelector(containerSelector);
    
    parseCtVideo(container);
    parseCtImage(container);
    // parseOther(container);
}

function parseOther(container) {
    // let ols = container.querySelectorAll('ol');

    // // console.log(ols);
    // ols.forEach(ol => {
    //     if (ol.classList.contains('list-style'))
    //         continue;
        
    //     ol.classList.add('list-style');
    // });

    let uls = container.querySelectorAll('ul');
    console.log(uls);
    uls.forEach(ul => {
        if (ul.classList.contains('list-style'))
            return;
        
        ul.classList.add('list-style');
    });
}

function parseCtImage(container) {
    let images = container.querySelectorAll('ct-image');

    images.forEach(image => {
        let status = image.getAttribute("status");
        

        let id_image = image.getAttribute("id_image");

        // if (id_im)
        let img_src = (id_image in editor_state.images_cache) ? editor_state.images_cache[id_image] : false;

        if (status == 'parsed' && id_image && !img_src) {
            m.request({
                method: "GET",
                url: "/api/media/get_image/"+id_image,
            }).then(function(data) {
                if (data.status == 200) {
                    editor_state.images_cache[id_image] = data.image.public_url;
                }
            });
        }

        if (status == 'parsed' && img_src) {
            status = 'rendered';
            
            image.setAttribute('status', 'rendered');
            // image.innerHTML = '<img src="'+img_src+'"/>';
            m.mount(image, { view: () => m(CtImage, {src: img_src}) });

            return;
        }

        if (status == 'parsed' || status == 'rendered') 
            return;

        image.setAttribute('status', 'parsed');


        // m.mount(image, m(Loader));
        m.mount(image, { view: () => m(Loader) });
        // image.innerHTML = '<img src="https://vectorified.com/images/google-photos-icon-5.png"/>';
        // image.innerHTML = '<img style="width:200px; height:auto" src="https://media0.giphy.com/media/xTkcEQACH24SMPxIQg/giphy.gif?cid=ecf05e476921d125af8f593f48c6b75dc8a89969a05af5a8&rid=giphy.gif"/>';
    });
}

function parseCtVideo(container) {
    let videos = container.querySelectorAll('ct-video');

    videos.forEach(video => {
        let status = video.getAttribute("status");
        
        let id_video = video.getAttribute("id_video");

        let video_src = (id_video in editor_state.videos_cache && editor_state.videos_cache[id_video].src) ? editor_state.videos_cache[id_video].src : false;

        if ((status == 'parsed' && id_video && !video_src) || status == 'procesing') {
            m.request({
                method: "GET",
                url: "/api/media/get_video/"+id_video,
            }).then(function(data) {
                if (data.status == 200) {
                    editor_state.videos_cache[id_video] = {
                        src: data.video.id_stream,
                        status: data.video.status
                    };
                }
            });
        }

        let video_status = id_video in editor_state.videos_cache ? editor_state.videos_cache[id_video].status : 'und';

        // if (status == 'parsed' && video_src) {
        if (status == 'parsed' && (video_status == 'uploading_service' || video_status == 'processed' || video_status == 'error')) {
            status = 'procesing';
            video.setAttribute('status', status);
            
            // video.innerHTML = '<img style="width:200px; height:auto" src="https://gifimage.net/wp-content/uploads/2018/04/processing-gif-14.gif"/>';
        }


        if (status == 'procesing' && (video_status == 'processed' || video_status == 'error')) {
            status = 'rendered';
            video.setAttribute('status', status);
            // video.innerHTML = '<img src="'+video_src+'"/>';

            if (video_status == 'error') {
                // TODO: HANDLE ERROR!
            }

            m.mount(video, { view: () => m(CtVideo, {src: video_src}) });

            return;
        }

        if (status == 'parsed' || status == 'procesing' || status == 'rendered') 
            return;

        video.setAttribute('status', 'parsed');

        m.mount(video, { view: () => m(Loader) });
        // video.innerHTML = '<img style="width:200px; height:auto" src="https://media0.giphy.com/media/xTkcEQACH24SMPxIQg/giphy.gif?cid=ecf05e476921d125af8f593f48c6b75dc8a89969a05af5a8&rid=giphy.gif"/>';
        // video.innerHTML = '<img style="width:200px; height:auto" src="https://gifimage.net/wp-content/uploads/2018/04/processing-gif-14.gif"/>';
    });
}


let contentEditorComponent = {
    oncreate: function() {
        editor_state.editor = Prosemirror.init('#contentEditor', '#content', 'exercise', editor_state.exercise.id_exercise);

        setInterval(e=>{ parseCustomTags('#contentEditor') }, 500);
        editor_state.exercise.content = parseToCustom();
        // console.log(editor_state.exercise.content);
    },

    view: function() {
        return [
            // m(toolbarComponent),
            m('#contentEditor.contentEditor--dark-theme'),
            m('#content', {style: 'display: none;'}, m.trust(editor_state.exercise.content))
        ]
    }
}

let Loader = {
    view: function(vnode) {
        return m('.loader.icon-spin', [
            m('svg', 
                {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 512 512"
                },
                [
                    m('path', {
                        d: "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
                    })
                ]
            )
        ]);
    }
}


let CtImage =  {
    view: function(vnode) {
        return[
            m('img', {
                style: "max-width:100%; height:auto",
                src: vnode.attrs.src
            })
        ];
    }
}

let CtVideo =  {
    view: function(vnode) {
        return[
            m('stream', {
                src: vnode.attrs.src,
                controls: true,
            }),
            m('script', {
                'data-cfasync': "false",
                defer: true,
                type: "text/javascript",
                src: "https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=" + vnode.attrs.src
            })
        ];
    }
}


class ExerciseContentEditor {
    oninit(vnode) {
        m.request({
            method: "GET",
            url: "/api/exercises/"+editor_state.id_exercise
        }).then(function(data) {
            editor_state.exercise = data;
            // editor_state.initial_state = data.content;
        });

        // window.onbeforeunload = function() {
        //     return editor_state.exercise.content != editor_state.editor.dom.innerHTML;
        // };
    }
    
    // oncreate() {

    // }

    view(vnode) {
    	return  m('.content-box', [
            editor_state.exercise &&
            m('.ijf-form', [
                m('.line', [
                    m('.line-element', [
                        // m('label', 'Title'),
                        m('label', trans('exercises.form.title')),
                        m('input', {
                            name: 'title',
                            id: 'title',
                            type: 'text',
                            value: editor_state.exercise.title,
                            onchange: e => editor_state.exercise.title = e.target.value,
                        })
                    ]),
                ]),
                
                m('.line', [
                    m('.line-element', [
                        m('label', trans('exercises.form.short_description')),
                        m('input', {
                            name: 'short_description',
                            id: 'short_description',
                            type: 'text',
                            value: editor_state.exercise.short_description,
                            onchange: e => editor_state.exercise.short_description = e.target.value,
                        })
                    ]),
                ]),
                
                m('.line', [
                    m('.line-element', [
                        m('label', trans('exercises.form.required_people')),
                        m('input', {
                            name: 'required_people',
                            id: 'required_people',
                            type: 'number',
                            min: 1,
                            max: 100,
                            step: 1,
                            value: editor_state.exercise.required_people,
                            onchange: e => editor_state.exercise.required_people = e.target.value,
                        })
                    ]),
                ]),
                
                m('.line', [
                    m('.line-element.line-element--checkbox', [
                        m('b', trans('exercises.form.is_judo_related')),
                        m('input', {
                            name: 'only_judo',
                            id: 'only_judo',
                            type: 'checkbox',
                            checked: editor_state.exercise.only_judo == 1,
                            onclick: e => editor_state.exercise.only_judo = editor_state.exercise.only_judo == 1 ? 0 : 1
                        })
                    ]),
                ]),

                m('.line', [
                    m('.line-element.line-element--checkbox', [
                        m('b', trans('exercises.form.is_only_kids')),
                        m('input', {
                            name: 'only_kids',
                            id: 'only_kids',
                            type: 'checkbox',
                            checked: editor_state.exercise.only_kids == 1,
                            onclick: e => editor_state.exercise.only_kids = editor_state.exercise.only_kids == 1 ? 0 : 1
                        })
                    ]),
                ]),

                m('.line', [
                    m('.line-element', [
                        m('label', trans('exercises.form.is_public')),
                        m('select', 
                            {
                                name: 'public',
                                id: 'public',
                                value: editor_state.exercise.public,
                                onchange: e => editor_state.exercise.public = e.target.value,
                            },
                            [
                                m('option', { value: 0 }, trans('exercises.form.private')),
                                m('option', { value: 1 }, trans('exercises.form.public')),
                            ]
                        )
                    ]),
                ]),

                m('.contentEditorContainer', [
                    m('label.form-label', trans('exercises.form.content')),
                    
                    m('div.form-helper', [
                        m('span', trans('challenge.content_editor_helper')),
                        m('span', trans('challenge.content_editor_helper.steps_of_exercise') + ' '),
                        m('span', m('img', {width: "20", height: "20", src: "/imgs/editor_icons/content-editor_list-icon.png"})),
                        m('span', ', ' + trans('challenge.content_editor_helper.upload_image') + ' '),
                        m('span', m('img', {width: "20", height: "20", src: "/imgs/editor_icons/content-editor_image-icon.png"})),
                        m('span', ' ' + trans('challenge.content_editor_helper.upload_video') + ' '),
                        m('span', m('img', {width: "20", height: "20", src: "/imgs/editor_icons/content-editor_video-icon.png"})),
                        m('span', ' .'),
                    ]),

                    m(contentEditorComponent),
                ]),

                editor_state.is_admin &&
                m('.line', [
                    m('.line-element', [
                        m('label', trans('exercises.form.validation_status')),
                        m('select', 
                            {
                                name: 'public',
                                id: 'public',
                                value: editor_state.exercise.validated == 1 ? 1 : (editor_state.exercise.rejected == 1 ? 2 : 0),
                                onchange: e => {
                                    if (e.target.value == 0) {
                                        editor_state.exercise.validated = 0;
                                        editor_state.exercise.rejected = 0;
                                    }

                                    if (e.target.value == 1) {
                                        editor_state.exercise.validated = 1;
                                        editor_state.exercise.rejected = 0;
                                    }

                                    if (e.target.value == 2) {
                                        editor_state.exercise.validated = 0;
                                        editor_state.exercise.rejected = 1;
                                    } 
                                },
                            },
                            [
                                m('option', { value: 0 }, trans('exercises.form.select_validation_status')),
                                m('option', { value: 1 }, trans('exercises.form.approve')),
                                m('option', { value: 2 }, trans('exercises.form.reject')),
                            ]
                        )
                    ]),
                ]),

                m('.line', [
                    m('div', [
                        m('label', trans('common.custom_thumbnail')),
                        m("button.btn.btn--main", {
                            onclick: change_thumbnail
                        }, trans('common.change_thumbnail_btn')),
                        UploadPageState.upload_state == UPLOADER_STATE.UPLOADING && m('div', 'Uploading...')
                    ])
                ]),

                editor_state.exercise.url_poster && m('.line', [
                    m('.line-element', [
                        m('img', {
                            id : 'exercise_poster',
                            src : editor_state.exercise.url_poster
                        })
                    ])
                ]),

                m('.line.line--center', 
                    m('.btn.btn--full-width.btn--main.btn--big', {
                        type: 'submit',
                        onclick: e => saveExercise()
                    }, trans('exercises.save_btn'))
                )
            ])
        ]);
    }
}

function change_thumbnail() {
    var input = document.createElement('input');

    input.type = 'file';
    input.accept = 'image/*';

    input.onchange = e => {
        var file = e.target.files[0];

        let extension = file.name.split('.').pop().toLowerCase();

        if (extension != 'png' && extension != 'jpg' && extension != 'jpeg' && extension != 'gif') {
            alert("Wrong file format. Supported: .png, .jpg and .gif");
            return;
        }

        let data = {
            type: 'image',
            entity: 'exercise',
            id_entity: editor_state.id_exercise,
            file: {
                name: file.name,
                size: file.size,
                type: file.type
            },
        };

        m.request({
            method: "POST",
            url: "/api/media",
            body: data
        }).then(function(data) {
            if (data.status == 200) {
                upload_image(file, data.id_uploaded, data.upload_url);
            } else {
                alert("ERROR!");
            }
        });
    };

    input.click();
}

function upload_image(file, id_image, upload_url) {
    let progress = 0;

    UploadPageState.upload_state = UPLOADER_STATE.UPLOADING;
    var xmlHttpRequest = new XMLHttpRequest();
    xmlHttpRequest.open("PUT", upload_url, true);

    xmlHttpRequest.setRequestHeader("Content-Type", file.type);

    xmlHttpRequest.upload.addEventListener("progress", function (e) {
        progress = (e.loaded / e.total) * 100;
        progress = Math.floor(progress);
        if (progress >= 100) {
            progress = 100;

            setTimeout(function () {
                m.request({
                    method: "GET",
                    url: '/api/media/upload_image_finished/' + id_image,
                }).then(function (data) {
                    console.log('UPLOADED!');
                    m.request({
                        method: "GET",
                        url: "/api/media/get_image/"+id_image,
                    }).then(function(data) {
                        if (data.status == 200) {
                            editor_state.exercise.url_poster = data.image.public_url;
                            $("#exercise_poster").attr("src",data.image.public_url);
                        }
                    });

                    UploadPageState.upload_state = UPLOADER_STATE.FINISHED;
                    alert("Successfully added image to exercise. To keep it you need to press save button bellow.");
                });
            }, 200);
        }
    });

    xmlHttpRequest.send(file);
}

function init(rootElement, id_exercise, is_admin) {

    if (!rootElement) {
        return;
    }

    editor_state.id_exercise = id_exercise;
    editor_state.is_admin = is_admin;

    m.mount(rootElement, ExerciseContentEditor);
}

export default init;
